import z from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';
import zod from 'zod';

export const SchoolClassFormSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, MANDATORY_FIELD),
  recognitionsId: zod.array(zod.number()).min(1, MANDATORY_FIELD),
  shiftId: z.number().nullable().optional(),
});
